var equips = new Array();  //Array s vybranými checkboxy vybavení


$(".checkbox").click(function () {
    var equip = $(this).data("equip");

    if(!$(this).hasClass("checked")){
        $(this).addClass("checked");
        equips.push(equip);
    }
    else{
        $(this).removeClass("checked");
        var key = equips.indexOf(equip);
        equips.splice(key, 1);
    }

});